<template>
	<div>
		<b-form-file
			:ref="'fileset_file_' + id"
			accept=".csv"
			@change="addTabulator"
			placeholder="Importer un csv pour édition"></b-form-file>
		
		<br />
		
		<div :id="'builder' + id"></div>

		<b-button variant="link" @click="reset">Reset</b-button>&nbsp;
		<b-button v-show="!view_sql" variant="link" @click="view_sql = true">Règles sql</b-button>

		<div v-show="view_sql">
			<b-form-input v-model="value" @change="updatePage" placeholder="Règles sql"></b-form-input>
			<br />
		</div>

		<edit_tabulator ref="tabulator" :extern_file="false" @data="update_tabulator"></edit_tabulator>
	</div>
</template>

<script>
	const chardet = require("chardet");

	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	import $ from "jquery";
	import alasql from "alasql";
	import * as CSV from "csv-string";
	import uniqueId from "lodash.uniqueid";

	import edit_tabulator from "./edit_tabulator.vue";

	export default {
		name: "filters_tabulator",
		components: {
			edit_tabulator
		},
		data: function () {
			return {
				data: [],
				tabulator_data: [],
				rules: "",
				rules_sql: "",
				request: "",
				value: "",
				id: uniqueId(""),
				tabulator_options: {
					columns: [],
				},
				tick: 0,
				view_sql: false
			};
		},
		watch: {
			tabulator_data: {
				deep: true,
				handler() {
					//this.$emit("update", this.tabulator_data);
					this.$refs.tabulator.load(this.tabulator_data);
				},
			},
		},
		mounted: async function () {
		},
		methods: {
			update_tabulator()
			{
				var self = this;

				this.$emit("update", this.$refs.tabulator.get_data());

				/*if (this.tick == 0)
				{
					this.$emit("update", this.$refs.tabulator.get_data());
				}
				this.tick++;
				this.$nextTick(async function () {
					self.tick = 0;
				})*/
			},
			save() {
				return {
					data: this.data,
					rules: this.rules,
					value: this.value,
					columns: this.tabulator_options.columns,
					view_sql: this.view_sql
				};
			},
			async load(data) {	
				console.log("load file editor");
				console.log(data);

				this.view_sql = data.view_sql;
				this.tabulator_options.columns = data.columns;
				this.data = data.data;
				this.value = data.value;
				try {
					this.setBuilder(Object.keys(this.data[0]));
					$("#builder" + this.id).queryBuilder(
						"setRules",
						data.rules
					);
					await this.updatePage();
				} catch (err) {
					this.tabulator_data = data.data;
				}
			},
			get_data() {
				return this.$refs.tabulator.get_data();
			},
			setBuilder(columns) {
				var self = this;
				var id = this.id;

				var columns_query_builder = [];
				for (var i = 0; i < columns.length; i++) {
					columns_query_builder.push({
						id: "`" + columns[i] + "`",
						label: columns[i],
						type: "string",
					});
				}

				var config = {
					filters: columns_query_builder,
					icons: {
						add_group: "fas fa-plus-square",
						add_rule: "fas fa-plus-circle",
						remove_group: "fas fa-minus-square",
						remove_rule: "fas fa-minus-circle",
						error: "fas fa-exclamation-triangle",
					},
					operators: [
						{ type: "equal" },
						{ type: "not_equal" },
						{ type: "less" },
						{ type: "less_or_equal" },
						{ type: "greater" },
						{ type: "greater_or_equal" },
						{ type: "between" },
						{ type: "contains" },
						{ type: "not_contains" },
						{ type: "begins_with" },
						{ type: "ends_with" },
						{
							type: "is_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
						{
							type: "is_not_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
					],
				};

				$("#builder" + id).queryBuilder(config);

				$("#builder" + id).on(
					"change",
					function (e, rule, error, value) {
						try {
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = " " + self.rules_sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							self.rules = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteRule.queryBuilder",
					function (e, rule, error, value) {
						try {
							//self.rules = $('#builder').queryBuilder('getRules');
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = " " + self.rules_sql;
							self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteGroup.queryBuilder",
					function (e, group) {
						try {
							self.rules_sql = " " + $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);
			},
			addTabulator: async function (event = null) {
				//console.log("add Tabulator")
				var self = this;
				var id = this.id;

				var file = null;
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];
				this.name_file_tabulator = file.name;
				var str = await file.arrayBuffer();
				var encoding = chardet.detect(Buffer.from(str));
				var str = new TextDecoder().decode(str);
				var separator = CSV.detect(str);
				if (separator != "," && separator != ";" && separator != "\t")
					separator = ",";
				this.$papa.parse(file, {
					encoding: encoding,
					delimiter: separator,
					header: true,
					skipEmptyLines: true,
					complete: function (results) {
						self.tabulator_data = results.data;
						self.data = results.data;
						var fields = results.meta.fields;
						var columns = [];
						for (var i = 0; i < fields.length; i++) {
							columns.push({
								title: fields[i],
								field: fields[i],
								editor: "textarea",
								headerContextMenu: this.headerContextMenu,
							});
						}
						try {
							$("#builder" + id).queryBuilder("destroy");
						} catch (err) {}

						self.setBuilder(fields);
						self.$refs["fileset_file_" + self.id].reset();
					},
				});
			},
			reset() {
				$("#builder" + this.id).queryBuilder("reset");
				this.rules_sql = "";
				this.view_sql = false;
				this.updatePage();
			},
			async updatePage(event = null) {
				console.log("updatePage")
				var pagination_size = 10;

				this.request = "";
				if (this.rules_sql) this.request = " WHERE " + this.rules_sql;
				if (this.value) this.request += " " + this.value;

				if (this.request)
				{
					this.tabulator_data = alasql(
						"SELECT * FROM ? " + this.request,
						[this.data]
					);
				}
				else
				{ 
					this.tabulator_data = this.data;
				}
			},
		},
	};
</script>
